<div class="text-center">
  <mat-horizontal-stepper orientation="vertical" (click)="onChangeStep()" #stepper>
    <mat-step *ngFor="let workInstruction of store.data$()" label="{{ workInstruction.id }}" class="active">
      <ng-template matStepLabel>{{ workInstruction.name }}</ng-template>
      <ng-template matStepContent>
        <div *ngIf="this.selectedRows().length === 1">
          <button mat-button (click)="initializeEdit()">{{ 'button.edit' | translate }}</button>
          <button mat-button (click)="initializeDelete()">{{ 'button.delete' | translate }}</button>
          <button mat-stroked-button (click)="onClickedApply()">
            {{ 'page.workInstructions.button.applyToCurrentStep' | translate }}
          </button>
        </div>
      </ng-template>
    </mat-step>
    <ng-template matStepperIcon="edit" let-index="index">
      <mat-icon>dashboard</mat-icon>
    </ng-template>
    <ng-template matStepperIcon="number" let-index="index">
      <mat-icon>dashboard</mat-icon>
    </ng-template>
  </mat-horizontal-stepper>
</div>

<ng-template #addEditFormDialog>
  <h1 mat-dialog-title>
    {{ addEditModalTitle() }}
  </h1>
  <form [formGroup]="addEditForm" (ngSubmit)="onFormDialogSubmit()">
    <div mat-dialog-content>
      <div class="row">
        <mat-form-field appearance="outline" *ngIf="!isBulkEdit()">
          <mat-label>{{ 'field.name' | translate }}</mat-label>
          <input matInput formControlName="name" />
          <mat-error [control]="addEditForm.get('name')"></mat-error>
        </mat-form-field>
      </div>
    </div>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>{{ 'button.cancel' | translate }}</button>
      <button mat-flat-button type="submit">
        {{ addEditSubmitButtonText() }}
      </button>
    </mat-dialog-actions>
  </form>
</ng-template>
